'use strict';

var processInclude = require('@sfra/util');
var util = require('./util/util');

$(document).ready(function () {
    // Load scripts only for Internet Explorer
    if (util.isIE()) {
        processInclude(require('./thirdParty/cssVarsPolyfill'));
    }
});
